import { Link } from "react-router-dom";

const ForgotPassword = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-700 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full bg-slate-800 p-10 rounded-3xl shadow-2xl border border-slate-700 relative animate-fade-in">
        <div className="flex justify-center mb-6">
          <div className="bg-slate-700 rounded-full p-3 shadow-md">
            <svg className="h-10 w-10 text-slate-300" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
        </div>

        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-center mb-6 text-slate-100">
            Feature Disabled
          </h2>
          <p className="text-slate-400 text-center mb-6">
            Password reset functionality has been disabled for security reasons.
          </p>
          <p className="text-slate-500 text-sm mb-8">
            Please contact your system administrator if you need to reset your password.
          </p>
        </div>

        <div className="text-center mt-6 text-sm">
          <Link
            to="/login"
            className="text-slate-300 hover:text-white font-medium transition-colors duration-200 hover:underline"
          >
            ← Back to Login
          </Link>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes fade-in {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.5s cubic-bezier(0.4, 0, 0.2, 1) both;
        }
      `}</style>
    </div>
  );
};

export default ForgotPassword;
